export const iconFontAwesomeCodingLaptopCode = (
	<i className="fa-solid fa-laptop-code"></i>
);
